/* LIBRAIRIES */
import React from 'react';

/* REACT ROUTER DOM */
import { useNavigate } from "react-router-dom";

/* FIREBASE */
import { list, ref, getDownloadURL, getMetadata } from 'firebase/storage';
import { storage } from '../../firebase';

/* CONTEXT */
import { useUserContext } from '../../useContext';

/* ICONS */
import { AiFillEye } from 'react-icons/ai';

/* CSS */
import './ViewBtn.css';

const ViewBtn = ({ id }) => {

    const { setUserMediasList, setOpenModalUserDocs, setUserId } = useUserContext();

    async function handleClick() {
        const userFilesRef = ref(storage, `medias/${id}`);
        const userFilesList = await list(userFilesRef);

        const userFilesArray = [];
        await Promise.all(userFilesList.items.map(async (itemRef) => {
            const downloadUrl = await getDownloadURL(itemRef);
            const metadata = await getMetadata(itemRef);
            userFilesArray.push({
                id: itemRef.name,
                url: downloadUrl,
                dateCreated: metadata.timeCreated,
                dateUpdated: metadata.updated,
                size: metadata.size,
                contentType: metadata.contentType,
                firstName: metadata?.customMetadata?.firstName,
                name: metadata?.customMetadata?.lastName,
                titre: metadata?.customMetadata?.title
            });
        }));
        setUserMediasList(userFilesArray);
        setOpenModalUserDocs(true);
        setUserId(id);
    }

    return (
        <button title="Voir le client" className='view-button' onClick={handleClick}>
            <AiFillEye className='btnView' />
        </button>
    )
}

export default ViewBtn;